<app-menu [hasChanges]="loadMenu" [title]="'Bienvenido al sistema Administrativo'"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="grid min-h-screen bg-white">
    <div class="col-12 md:col-4">
        <p-card class="border-round text-center  min-h-full">
            <ng-template pTemplate="header" class="pt-2">
                <div class="text-center pt-2">
                    <img src="assets/img/AsignarVendedores.jpg" style="width:200px" alt="">
                </div>
            </ng-template>
            <p>Realice la creación e inactivación de vendedores que estan involucrados para lograr la meta asignada</p>
            <ng-template pTemplate="footer">
                <button pButton class="p-button p-button-success" label="Creación y/o actualización de vendedores"
                    (click)="openDialogCreateUser()" icon="pi pi-eye"></button>
            </ng-template>
        </p-card>
    </div>

    <div class="col-12 md:col-4">
        <p-card class="border-round">
            <ng-template pTemplate="header">
                <div class="text-center pt-2">
                    <h4>Indicador general de ventas del día actual</h4>
                </div>
            </ng-template>

            <div class="card flex justify-content-center">
                <apx-chart [colors]="chartOptions.fill.colors" [series]="chartOptions?.series"
                    [chart]="chartOptions?.chart" [labels]="chartOptions?.labels" [yaxis]="chartOptions?.yaxis"
                    [title]="chartOptions?.title" #chart2></apx-chart>
            </div>
            <ng-template pTemplate="footer">
                <div class="flex justify-content-center">
                    <div class="w-6 p-2 align-items-center justify-content-center">
                        <div class="bg-green-500 p-3 text-white text-center border-round">
                            <p class="text-white">Venta del día: <br>{{chartOptions.series[0] | currency}}</p>
                        </div>
                    </div>
                    <div class="w-6 p-2 align-items-center justify-content-center">
                        <div class="bg-simescco p-3 text-white text-center border-round min-h-full">
                            <p class="text-white">Meta faltante:<br> {{chartOptions.series[1] | currency}}</p>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-card>
    </div>

    <div class="col-12 md:col-4">
        <p-card class="border-round">
            <ng-template pTemplate="header">
                <div class="text-center pt-2">
                    <h4>Alertas</h4>
                </div>
            </ng-template>
            <div class="p-message m-1 p-2 p-message-{{row.type}}" *ngFor="let row of alerts">
                {{row.text}}
            </div>
            <div class="p-message m-1 p-2 p-message-success" *ngIf="alerts.length==0">
                Sin novedad alguna
            </div>
            <ng-template pTemplate="footer">

            </ng-template>
        </p-card>
    </div>

    <p-dialog id="dialog" [(visible)]="display" [modal]="true" [style]="{width:'80%'}">
        <ng-template #header>
            <div class="inline-flex items-center justify-center gap-2 uppercase">
                <h4>Creación y/o actualización de vendedores</h4>
            </div>
        </ng-template>
        <div class="flex flex-row align-items-center gap-2">
            <div class="p-inputgroup">
                <input type="text" pInputText placeholder="Buscador de empleados" [(ngModel)]="filterUser"
                    (keyup)="filterUsers()">
            </div>
            <div class="p-inputgroup mt-1 w-auto">
                <p-checkbox [(ngModel)]="checkedStateUser" (onChange)="filterUsers()" [binary]="true"
                    label="Ver activos"></p-checkbox>
            </div>
        </div>
        <p-divider></p-divider>
        <h3 class="uppercase">Lista de Empleados</h3>
        <div *ngFor="let row of listSalesFilter; let last=last">
            <div class="p-inputgroup flex justify-content-between align-items-center">
                {{row.nombres + ' ' + row.apellidos}}
                <button pButton icon="pi pi-eye" (click)="actionSelectedVendors(row.identificacion)"
                    class="p-button p-button-success"></button>
            </div>
            <hr *ngIf="!last">
        </div>
        <p-divider></p-divider>
        <!--Div apara adicionar nuevos vendedores-->
        <p-fieldset legend="ADICIONAR VENDEDOR" [toggleable]="true" [collapsed]="true"
            (onAfterToggle)="addUser($event)">
            <div class="flex flex-wrap gap-3 justify-content-center" *ngFor="let item of newUser">
                <div class="w-full md:w-5">
                    <label>Identificación</label>
                    <div class="p-inputgroup">
                        <input type="text" [(ngModel)]="item.identificacion" placeholder="Identificación" pInputText pSize="small">
                    </div>
                </div>
                <div class="w-full md:w-5">
                    <label>Nombres</label>
                    <div class="p-inputgroup">
                        <input type="text" [(ngModel)]="item.nombres" placeholder="Nombres completos" pInputText pSize="small">
                    </div>
                </div>
                <div class="w-full md:w-5">
                    <label>Apellidos</label>
                    <div class="p-inputgroup">
                        <input type="text" [(ngModel)]="item.apellidos" placeholder="Apellidos completos" pInputText pSize="small">
                    </div>
                </div>
                <div class="w-full md:w-5">
                    <label>Genero</label>
                    <div class="p-inputgroup">
                        <p-select [options]="lsSexo" optionLabel="label" [(ngModel)]="item.genero" optionValue="id" pSize="small">
                        </p-select>
                    </div>
                </div>
                <div class="w-full md:w-5">
                    <label>Fecha de nacimiento</label>
                    <div class="p-inputgroup">
                        <p-datepicker placeholder="dd-mm-yyyy" [(ngModel)]="item.fechaNacimiento"
                            showIcon [monthNavigator]="true" [yearNavigator]="true" yearRange="1950:2030" size="small"/>
                    </div>
                </div>
                <div class="w-full md:w-5">
                    <label>Correo electrónico</label>
                    <div class="p-inputgroup">
                        <input type="email" [(ngModel)]="item.email" placeholder="Correo electrónico" pInputText pSize="small">
                    </div>
                </div>
                <!--Componente a visualizar si esta activo el integrador-->
                <div class="w-full md:w-5"
                    *ngIf="(!infoParametrizacion.integrationSystem?'':infoParametrizacion?.integrationSystem) !==''">
                    <label>Identificador {{infoParametrizacion?.integrationSystem}}</label>
                    <div class="p-inputgroup">
                        <input type="number" [(ngModel)]="item.idUserIntegrationSystem" pInputText>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <span [innerHTML]="item.msgUser"></span>
                    <br>
                    <button pButton icon="pi pi-save" label="Guardar cambios" class="p-button p-button-success"
                        (click)="createUser(item, true)"></button>
                </div>
            </div>
        </p-fieldset>
        <p-footer>
            <button pButton class="p-button p-button-danger" label="Cerrar" icon="pi pi-times-circle"
                (click)="display=false;"></button>
        </p-footer>
    </p-dialog>
    <!--Dialogo para la actualización de vendedores-->
    <p-dialog id="dialog" [(visible)]="displayVendors" [modal]="true" [style]="{width:'60%'}">
        <ng-template #header>
            <div class="inline-flex items-center justify-center gap-2 uppercase">
                <h4>Actualización de vendedores</h4>
            </div>
        </ng-template>

        <p-fieldset id="divUpdateUser" legend="{{salesSelected.nombres + ' ' + salesSelected.apellidos}}"
            [toggleable]="true" [collapsed]="false" (onAfterToggle)="addUser($event)">
            <div class="flex flex-wrap">
                <div class="w-full md:w-6 p-2">
                    <label>Identificación</label>
                    <div class="p-inputgroup">
                        <input type="text" [(ngModel)]="salesSelected.identificacion" placeholder="Identificación" pSize="small"
                            pInputText>
                    </div>
                </div>
                <div class="w-full md:w-6 p-2">
                    <label>Nombres</label>
                    <div class="p-inputgroup">
                        <input type="text" [(ngModel)]="salesSelected.nombres" placeholder="Nombres completos" pSize="small"
                            pInputText>
                    </div>
                </div>
                <div class="w-full md:w-6 p-2">
                    <label>Apellidos</label>
                    <div class="p-inputgroup">
                        <input type="text" [(ngModel)]="salesSelected.apellidos" placeholder="Apellidos completos" pSize="small"
                            pInputText>
                    </div>
                </div>
                <div class="w-full md:w-6 p-2">
                    <label>Genero</label>
                    <div class="p-inputgroup">
                        <p-select [options]="lsSexo" optionLabel="label" [(ngModel)]="salesSelected.genero" size="small"
                            optionValue="id"></p-select>
                    </div>
                </div>
                <div class="w-full md:w-6 p-2">
                    <label>Fecha de nacimiento</label>
                    <div class="p-inputgroup">
                        <p-datepicker placeholder="dd-mm-yyyy" dateFormat="dd-mm-yy" [showIcon]="true" inputId="icon"
                            [(ngModel)]="salesSelected.fechaNacimiento" [monthNavigator]="true" [yearNavigator]="true"
                            yearRange="1940:2030" size="small"/>
                    </div>
                </div>
                <div class="w-full md:w-6 p-2">
                    <label>Correo electrónico</label>
                    <div class="p-inputgroup">
                        <input type="email" [(ngModel)]="salesSelected.email" placeholder="Correo electrónico" pSize="small"
                            pInputText>
                    </div>
                </div>
                <!--Componente a visualizar si esta activo el integrador-->
                <div class="w-full md:w-6 p-2"
                    *ngIf="(!infoParametrizacion.integrationSystem?'':infoParametrizacion?.integrationSystem) !==''">
                    <label>Identificador {{infoParametrizacion.integrationSystem }}</label>
                    <div class="p-inputgroup">
                        <input type="number" [(ngModel)]="salesSelected.idUserIntegrationSystem" pInputText pSize="small">
                    </div>
                </div>
                <div class="w-full md:w-6 p-2">
                    <label>Activo</label>
                    <div class="flex flex-wrap gap-4">
                        <div class="flex items-center">
                            <p-radioButton name="estado" [(ngModel)]="salesSelected.activo" value="1" inputId="estado1">
                            </p-radioButton>
                            <label for="estado1" class="ml-2">SI</label>
                        </div>&nbsp;
                        <div class="flex items-center">
                            <p-radioButton name="estado" [(ngModel)]="salesSelected.activo" value="0" inputId="estado2">
                            </p-radioButton>
                            <label for="estado2" class="ml-2">No</label>
                        </div>
                    </div>
                </div>
                <div class="w-full text-center">
                    <span [innerHTML]="salesSelected.msgUser"></span>
                    <br>
                    <button pButton icon="pi pi-save" label="Guardar cambios" class="p-button p-button-success"
                        (click)="createUser(salesSelected)"></button>
                </div>
            </div>
        </p-fieldset>
        <p-footer>
            <button pButton class="p-button p-button-danger" label="Cerrar" icon="pi pi-times-circle"
                (click)="displayVendors=false;"></button>
        </p-footer>
    </p-dialog>
</div>


<!-- <label>Probando
    <input type="text" list="listaExample">
</label>
<datalist id="listaExample">
    <option value="prueba 1"></option>
    <option value="cars"></option>
    <option value="cas 1"></option>
    <option value="pato 1"></option>
</datalist> -->
<app-footer></app-footer>